module.exports = __webpack_public_path__ + "createstatic/media/rev-logo.5c7564a6.png";